// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zngH","col":"styles_col__3CkpH"};